import { render, staticRenderFns } from "./Defaultlayout.vue?vue&type=template&id=6dac34e0"
import script from "./Defaultlayout.vue?vue&type=script&lang=js"
export * from "./Defaultlayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports